// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: unset;\n  margin-left: unset;\n}\n.info-row {\n  padding: 2px 0px;\n}\n.panelRow {\n  border-bottom: solid 1px #ccc;\n  padding: 10px 0px 10px 0px;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
